var exports = {
  "kL": "x4ddf2309--831f9b--container",
  "Sl": "x4ddf2309--831f9b--image",
  "h_": "x4ddf2309--831f9b--description",
  "cv": "x4ddf2309--831f9b--add-village-btn",
  "o1": "x4ddf2309--831f9b--actions",
};

module.exports = exports;
